import { Box, IconButton, Paper } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { action, controller, Server } from "../../api/Server";
import {
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CategoryList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [cats, setCats] = useState([]);
  const { catId } = useParams();

  useEffect(() => {
    Server(controller.PosDefaultCat + action.GetDefaultPosCats).get((res) => {
      if (res && res.status === 200) setCats([...res.result]);
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scroll = (e, direction) => {
    if (scrollRef.current) {
      const scrollAmount = 250; // Adjust scroll distance as needed
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const arrow_btn_class = {
    backgroundColor: "#4343431c",
    padding: 0,
    color: "#3d4e5f",
    height: "50px",
    borderRadius: "7px",
    "&:hover": {
      backgroundColor: "#007bff",
      color: "#fff",
    },
  };

  const handleOpenCatProducts = (categoryId) => {
    if (categoryId === parseInt(catId)) {
      navigate("/pos/products");
    } else {
      navigate(`/pos/products/${categoryId}`);
    }
  };

  return cats.length > 0 ? (
    <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
      <div
        style={{
          position: "absolute",
          left: 0,
          zIndex: 1000,
        }}
      >
        <IconButton
          size="small"
          onClick={(e) => scroll(e, "left")}
          sx={arrow_btn_class}
        >
          <KeyboardArrowLeftRounded className="fs-20" />
        </IconButton>
      </div>
      <Box
        ref={scrollRef}
        className="d-flex a-center g-10 pos-relative"
        sx={{
          overflow: "auto",
          scrollBehavior: "smooth",
          m: "0px 30px 0px 30px",
          pb: "15px",
          "&::-webkit-scrollbar": {
            display: "none", // Hides the scrollbar
          },
        }}
      >
        {cats.map((cat, ind) => (
          <Paper
            onClick={() => handleOpenCatProducts(cat.categoryId)}
            key={ind}
            className="d-grid p-10 g-5"
            sx={{
              minWidth: "150px",
              bgcolor: "#fff",
              cursor: "pointer",
              border: "none",
              boxShadow: "var(--shadow-sm)",
              borderBottom:
                parseInt(catId) === cat.categoryId
                  ? "2px solid var(--primary-color)"
                  : "2px solid transparent",
            }}
          >
            <span
              className="gray-color fw-5 fs-18 "
              style={{ width: "max-content" }}
            >
              {cat.categoryName}
            </span>
            <span className="fs-12 gray-color fw-5 tx-upp">
              {t("totalProducts")}: {cat.productCount}
            </span>
          </Paper>
        ))}
      </Box>

      <div
        style={{
          position: "absolute",
          right: 0,
          zIndex: 1000,
          width: "fit-content",
        }}
      >
        <IconButton
          size="small"
          onClick={(e) => scroll(e, "right")}
          sx={arrow_btn_class}
        >
          <KeyboardArrowRightRounded className="fs-20" />
        </IconButton>
      </div>
    </Box>
  ) : (
    ""
  );
};

export default CategoryList;
